module.exports = __webpack_public_path__ + "static/media/auth.8d360f29.jpg";